// extracted by mini-css-extract-plugin
export default {"fixedWrapper":"WriteButton_fixedWrapper__ldA1o","button":"WriteButton_button__Hy+3m"};